import React, { HTMLAttributes, useCallback } from 'react';

import classNames from 'classnames';

import { Button } from '@ast/magma/components/button';
import { StatusLevel } from '@ast/magma/components/dialog';

import { WizardStepCard, WizardStepSizes } from '../WizardStepCard';

import style from './ResultWizardStep.pcss';
import { StatusWizardStep } from './StatusWizardStep';

export interface ResultWizardStepProps extends HTMLAttributes<HTMLSpanElement> {
  readonly wizardStepSize?: WizardStepSizes;
  readonly level: StatusLevel;
  readonly title: string;
  readonly buttonText: string;
  readonly buttonStableName?: string;
  readonly handleButtonClick: () => void;
  readonly contentClassName?: string;
  readonly buttonClassName?: string;
}

/**
 * The last step of wizard flow.
 * Appeared as container with title, message and action button
 */
export const ResultWizardStep: React.FC<ResultWizardStepProps> = ({
  wizardStepSize,
  level,
  title,
  children,
  buttonText,
  buttonStableName,
  handleButtonClick,
  contentClassName,
  buttonClassName,
}: ResultWizardStepProps) => {
  const buttons = useCallback(() => (
    <Button
      look="outlined"
      className={classNames(style.button, buttonClassName)}
      onClick={handleButtonClick}
      data-stable-name={buttonStableName ?? 'WizardResultButton'}
    >
      {buttonText}
    </Button>
  ), [buttonText, buttonStableName, handleButtonClick]);

  return (
    <WizardStepCard
      loading={false}
      size={wizardStepSize || 'small'}
    >
      <StatusWizardStep
        level={level}
        title={title}
        buttons={buttons}
        contentClassName={contentClassName}
      >
        {children}
      </StatusWizardStep>
    </WizardStepCard>
  );
};
